export const GET_ALL_BREED_LIST = 'GET_ALL_BREED_LIST'
export const GET_ALL_BREED_LIST_SUCCESS = 'GET_ALL_BREED_LIST_SUCCESS'

// submitConfigureBreedList
export const ADD_BREED_CONFIGURE = 'ADD_BREED_CONFIGURE'
export const GET_BREED_CONFIGURE_DATA = 'GET_BREED_CONFIGURE_DATA'
export const GET_BREED_CONFIGURE_DATA_SUCCESS = 'GET_BREED_CONFIGURE_DATA_SUCCESS'
